export default __webpack_public_path__ + "static/media/i01.1fb7cd04.svg";